import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { Space, Table, Flex } from 'antd';
import { useQiyeListQuery } from '../../store/dianshangtaizhangApi';
import FirmAdd from './FirmAdd';
import FirmEdit from './FirmEdit';
import FirmUserList from '../firmUser/FirmUserList';
function QFirmList() {
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [list, setList] = useState([]);    

    // 无条件调用所有可能的hooks
    const { data, isSuccess  } = useQiyeListQuery(
        {}, 
        {refetchOnMountOrArgChange: true }
    );


    useEffect(() => {
        if (isSuccess && data) {
            setList(data.Result);
        }
    }, [data, isSuccess]);

    const columns = [       
        {
            key: 'qy_name',
            title: '企业',            
            dataIndex: 'qy_name',
        },       
        {
            key: 'qy_state',
            title: '状态',            
            dataIndex: 'qy_state',
        },
           
        {
            key: 'qy_uname',
            title: '操作时间',            
            dataIndex: 'qy_uname',
            render: (_, record) => (
                <Space>{record.qy_uname + record.qy_ctime}</Space>
            )
        },  
        {
            key: 'key',
            title: '编号',            
            dataIndex: 'qy_id',
        },  
        {
            key: 'action',
            title: '操作',
            render: (_, record) => (
                <Space>
                    <FirmEdit 
                        qy_id={record.qy_id} 
                        qy_name={record.qy_name} 
                        eu_id={eu_id} 
                        eu_name={eu_name} 
                    />
                    <FirmUserList qy_id={record.qy_id} qy_name={record.qy_name}/>
                </Space>
            )
        },
    ];   

    return (
        <Main selectedKeys={['/QFirmList']}>
            <Flex justify='flex-end'>
                <FirmAdd eu_id={eu_id} eu_name={eu_name}/>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    showTotal: (total) => `共${total}条`,
                }} 
                style={{ marginTop: '10px' }}
                rowKey='qy_id'
            />
        </Main>
    )
}

export default QFirmList